
<script>
import su1SurveyEN from "./su1SurveyComponentEN.vue";
import su1SurveyTR from "./su1SurveyComponentTR.vue";



export default {
    components: {
        su1SurveyEN,
        su1SurveyTR
    },
    
    data() {
        return {
            languages: [
                {
                    value: "en",
                    text: "English",
                    shortText: "EN",
                },
                {
                    value: "tr",
                    text: "Türkçe",
                    shortText: "TR",
                }
            ],
            
            selectedLanguage: "en",

            loading: false,

            clientWidth: window.innerWidth,
        }
    },

    computed: {
        showElement() {
          return this.clientWidth > 768;
        },
    },

    mounted() {
        window.addEventListener("resize", this.handleResize);
        this.selectedLanguage = this.normalizeLanguage(navigator.language);

        if (this.selectedLanguage.includes("en") || this.selectedLanguage.includes("tr")) {
            this.selectedLanguage = this.selectedLanguage;
        } else {
            this.selectedLanguage = "en";
        }
    },

    methods: {
        selectLanguage(item) {
            this.selectedLanguage = item.value;
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 500);
        },

        normalizeLanguage(lang) {
          const normalized = lang.split("-")[0];
          return normalized;
        },

        handleResize() {
          this.clientWidth = window.innerWidth;
        },
    },
}
</script>

<template>
  <div>
        <div v-if="loading">
          <loading-spinner />
        </div>
        <div class="language-selection-wrapper">
          <div class="inner-language-selection-wrapper">
            <select class="language-select" v-model="selectedLanguage">
                <option v-for="item in languages" :key="item.value" :value="item.value">
                    <span v-if="showElement">{{ item.text }}</span>
                    <span v-else>{{ item.shortText }}</span>
                </option>
            </select>
            <i class="mdi mdi-translate language-icon"></i>
          </div>
        </div>
        <su1SurveyEN v-if="selectedLanguage == 'en'"/>
        <su1SurveyTR v-if="selectedLanguage == 'tr'"/>
</div>
</template>

<style scoped lang="scss">
    .language-selection-wrapper {
      position: absolute;
      min-width: 150px;
      width: 7.5%;
      right: 3em;
      top: 1em;

      .inner-language-selection-wrapper {
        position: relative;
        width: 100%;

        > select {
          padding: .5em;
        
          width: 100%;
          height: fit-content;

          border: 0;

          outline: thin solid var(--sustainfinity-navy);

          border-radius: 1em;
        }
    
        > .language-icon {
          position: absolute;
          right: 1em;
          top: 35%;
          transform: translate(0, -50%);
          font-size: 1.33em;
          color: var(--sustainfinity-navy);
        }
      }     
    }

    @media screen and (max-width: 1200px){
        .language-selection-wrapper {
          right: 1em !important;
        }
    }
    @media screen and (max-width: 768px) {
      .language-selection-wrapper {
        min-width: 80px;
        right: 1em;
        top: 1em;
      }
    }


</style>